import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Simge } from './Simge.js';
import { UyariSerit } from './temel.js';

/**
 * Ortak diyalog. Esc kapatır, arka plan tıklaması kapatır, açıkken sayfa
 * kaydırılmaz. Telefonda alttan açılan sayfa gibi davranır.
 */
export function Pencere({
  baslik, alt, boyut = '', kapat, children, altBolum,
}: {
  baslik: ReactNode;
  alt?: ReactNode;
  boyut?: '' | 'genis' | 'cok-genis';
  kapat: () => void;
  children: ReactNode;
  altBolum?: ReactNode;
}) {
  useEffect(() => {
    const tus = (e: KeyboardEvent) => { if (e.key === 'Escape') kapat(); };
    document.addEventListener('keydown', tus);
    const eski = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', tus);
      document.body.style.overflow = eski;
    };
  }, [kapat]);

  return createPortal(
    <div className="perde" onMouseDown={(e) => { if (e.target === e.currentTarget) kapat(); }}>
      <div className={`pencere ${boyut}`} role="dialog" aria-modal="true" aria-label={typeof baslik === 'string' ? baslik : undefined}>
        <header className="pencere-baslik">
          <div>
            <h2>{baslik}</h2>
            {alt && <div className="alt">{alt}</div>}
          </div>
          <button className="btn btn-sade btn-simge" onClick={kapat} aria-label="Kapat">
            <Simge ad="carpi" />
          </button>
        </header>
        <div className="pencere-govde">{children}</div>
        {altBolum && <footer className="pencere-alt">{altBolum}</footer>}
      </div>
    </div>,
    document.body,
  );
}

/** Geri alınamaz işlemler için tek tip onay. */
export function OnayPenceresi({
  baslik, aciklama, onayMetni = 'Sil', tehlike = true, kapat, onayla, calisiyor, hata,
}: {
  baslik: string; aciklama: ReactNode; onayMetni?: string; tehlike?: boolean;
  kapat: () => void; onayla: () => void; calisiyor?: boolean;
  /** İşlem başarısızsa kullanıcıya gösterilecek mesaj. Verilmezse hata
   *  sessizce yutulur ve kullanıcı işlemin yapıldığını sanır. */
  hata?: string | null;
}) {
  return (
    <Pencere
      baslik={baslik}
      kapat={kapat}
      altBolum={
        <>
          <button className="btn btn-sade" onClick={kapat} disabled={calisiyor}>Vazgeç</button>
          <button
            className={`btn ${tehlike ? 'btn-tehlike' : 'btn-birincil'}`}
            onClick={onayla}
            disabled={calisiyor}
          >
            {calisiyor ? 'Uygulanıyor…' : onayMetni}
          </button>
        </>
      }
    >
      <p style={{ color: 'var(--metin-2)', fontSize: 'var(--p-14)' }}>{aciklama}</p>
      {hata && <UyariSerit ton="kritik">{hata}</UyariSerit>}
    </Pencere>
  );
}
